/**
 * Custom Hat Showcase – Auto-advancing slider
 * Reads data-duration (ms) from .hat-showcase element.
 * Mobile: one-at-a-time horizontal swipe slider with scroll-snap.
 */
(function () {
    var MOBILE_BP = 749;

    function isMobile() {
        return window.innerWidth <= MOBILE_BP;
    }

    document.querySelectorAll('.hat-showcase').forEach(function (section) {
        var slides = section.querySelectorAll('.hat-showcase__slide');
        var images = section.querySelectorAll('.hat-showcase__image');
        var total = slides.length;
        if (total === 0) return;

        var duration = parseInt(section.dataset.duration, 10) || 5000;
        var current = 0;
        var timer = null;
        var paused = false;
        var visible = true;
        var isScrolling = false;

        /* ---- helpers ---- */
        function activate(index, skipScroll) {
            // Mark the previously active slide as "leaving" for exit animation
            slides.forEach(function (s, i) {
                if (s.classList.contains('is-active') && i !== index) {
                    s.classList.remove('is-active');
                    s.classList.add('is-leaving');
                    (function (el) {
                        setTimeout(function () {
                            el.classList.remove('is-leaving');
                        }, 400);
                    })(s);
                }
            });

            // Activate the new slide
            slides[index].classList.remove('is-leaving');
            slides[index].classList.add('is-active');

            // Reset ALL bar fills first, then animate the active one
            slides.forEach(function (s) {
                var b = s.querySelector('.hat-showcase__bar-fill');
                if (b) {
                    b.style.animation = 'none';
                    void b.offsetWidth;
                }
            });

            var bar = slides[index].querySelector('.hat-showcase__bar-fill');
            if (bar) {
                bar.style.animation = 'hatBarFill ' + (duration / 1000) + 's linear forwards';
            }

            // Switch image with slide animation
            images.forEach(function (img, i) {
                if (i === index) {
                    img.classList.remove('is-leaving');
                    img.classList.add('is-active');
                } else if (img.classList.contains('is-active')) {
                    img.classList.remove('is-active');
                    img.classList.add('is-leaving');
                    (function (el) {
                        setTimeout(function () {
                            el.classList.remove('is-leaving');
                        }, 600);
                    })(img);
                }
            });

            current = index;

            // Scroll slides row to keep active slide visible
            if (!skipScroll) {
                var slidesRow = section.querySelector('.hat-showcase__slides');
                if (slidesRow) {
                    if (isMobile()) {
                        // Mobile: scroll to exact slide position (full-width per slide)
                        isScrolling = true;
                        slidesRow.scrollTo({ left: index * slidesRow.clientWidth, behavior: 'smooth' });
                        setTimeout(function () { isScrolling = false; }, 500);
                    } else {
                        var activeSlide = slides[index];
                        var slideLeft = activeSlide.offsetLeft;
                        var slideWidth = activeSlide.offsetWidth;
                        var containerWidth = slidesRow.clientWidth;
                        var maxScroll = slidesRow.scrollWidth - containerWidth;

                        if (index === total - 1) {
                            slidesRow.scrollTo({ left: maxScroll, behavior: 'smooth' });
                        } else if (index === 0) {
                            slidesRow.scrollTo({ left: 0, behavior: 'smooth' });
                        } else if (slideLeft + slideWidth > slidesRow.scrollLeft + containerWidth) {
                            slidesRow.scrollTo({ left: slideLeft + slideWidth - containerWidth, behavior: 'smooth' });
                        } else if (slideLeft < slidesRow.scrollLeft) {
                            slidesRow.scrollTo({ left: slideLeft, behavior: 'smooth' });
                        }
                    }
                }
            }
        }

        function next() {
            activate((current + 1) % total);
        }

        function scheduleNext() {
            stopTimer();
            timer = setTimeout(function tick() {
                if (paused || !visible) {
                    timer = setTimeout(tick, 200);
                    return;
                }
                next();
                timer = setTimeout(tick, duration);
            }, duration);
        }

        function stopTimer() {
            if (timer) { clearTimeout(timer); timer = null; }
        }

        /* ---- click to jump ---- */
        slides.forEach(function (slide, i) {
            slide.addEventListener('click', function () {
                activate(i);
                scheduleNext();
            });
        });

        /* ---- Mobile: detect swipe via scroll-snap end ---- */
        var slidesRow = section.querySelector('.hat-showcase__slides');
        var scrollTimeout = null;

        if (slidesRow) {
            slidesRow.addEventListener('scroll', function () {
                if (!isMobile() || isScrolling) return;
                clearTimeout(scrollTimeout);
                scrollTimeout = setTimeout(function () {
                    var containerWidth = slidesRow.clientWidth;
                    var newIndex = Math.round(slidesRow.scrollLeft / containerWidth);
                    if (newIndex >= 0 && newIndex < total && newIndex !== current) {
                        activate(newIndex, true); // skipScroll since user already scrolled
                        scheduleNext();
                    }
                }, 100);
            });
        }

        /* ---- IntersectionObserver: pause when off-screen ---- */
        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    visible = entry.isIntersecting;
                });
            }, { threshold: 0.25 });
            observer.observe(section);
        }

        /* ---- page visibility: stop when tab hidden ---- */
        document.addEventListener('visibilitychange', function () {
            if (document.hidden) {
                stopTimer();
            } else {
                activate(current);
                scheduleNext();
            }
        });

        /* ---- init ---- */
        section.style.setProperty('--hat-duration', (duration / 1000) + 's');

        /* ---- equalize desc heights (desktop only) ---- */
        var descs = section.querySelectorAll('.hat-showcase__desc');
        if (descs.length && window.innerWidth > 768) {
            var maxH = 0;
            descs.forEach(function (d) {
                d.style.maxHeight = 'none';
                d.style.opacity = '1';
                d.style.position = 'absolute';
                d.style.visibility = 'hidden';
                var h = d.scrollHeight;
                if (h > maxH) maxH = h;
                d.style.maxHeight = '';
                d.style.opacity = '';
                d.style.position = '';
                d.style.visibility = '';
            });
            if (maxH > 0) {
                descs.forEach(function (d) {
                    d.style.minHeight = maxH + 'px';
                });
            }
        }

        activate(0);
        scheduleNext();
    });
})();

